/* Afroyla Daughters Day (DD DEAL) page — shared core: clock, formatters, cart add, hero countdown, phase.
 * Loaded first (defer); exposes window.AFDD for afroyla-dd-lightning-deals.js + afroyla-dd-ongoing-deals-grid.js.
 * QA clock: ?ddnow=2026-09-25T14:30 (read as ET, -04:00) — the clock keeps ticking from that moment. */
(function () {
  var root = document.querySelector('[data-add]');
  if (!root) return;

  // ---- clock (optionally shifted for QA) ----
  var offset = 0;
  try {
    var q = new URLSearchParams(location.search).get('ddnow');
    if (q) {
      var iso = /T\d\d:\d\d$/.test(q) ? q + ':00-04:00' : /[+-]\d\d:\d\d$|Z$/.test(q) ? q : q + '-04:00';
      var t = Date.parse(iso);
      if (!isNaN(t)) offset = t - Date.now();
    }
  } catch (e) { /* ignore bad override */ }
  function now() { return Date.now() + offset; }

  var START = Date.parse(root.dataset.start);
  var END = Date.parse(root.dataset.end);

  // ---- formatters ----
  function money(n) { return '$' + Number(n).toFixed(2); }
  function pct(price, compare) { return compare > price ? Math.round(100 - (100 * price) / compare) : 0; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function hms(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
  }
  function mmss(d) { var s = Math.max(0, Math.ceil(d / 1000)); return Math.floor(s / 60) + ':' + pad(s % 60); }
  var etFmt = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour: 'numeric', minute: '2-digit' });
  function etTime(ts) { return etFmt.format(new Date(ts)); }
  // Shoppers are in many time zones: every absolute time reads "11:59 PM ET (8:59 PM PDT your time)";
  // the local part is dropped when the visitor's zone matches ET. Countdowns stay the primary signal.
  var localFmt = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
  var localPlain = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' });
  function whenLabel(ts) {
    var d = new Date(ts);
    var et = etFmt.format(d) + ' ET';
    return localPlain.format(d) === etFmt.format(d) ? et : et + ' (' + localFmt.format(d) + ' your time)';
  }
  function img(src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cleanTitle(t) { return String(t).replace(/\s*-?\s*DD\s*DEAL\s*$/i, '').replace(/\s+/g, ' ').trim(); }
  // Pill labels for a product's variant names: drops option parts shared by every variant, tidies the rest.
  // ["Medium / Top-Grain Leather (Italian…)", "Medium / Premium Vegan Leather"] → ["Top-Grain Leather", "Vegan Leather"]
  // 4-variant sets keep size: "Small · Top-Grain". short=true also drops "Leather" (grid cards).
  function variantLabels(names, short) {
    var parts = names.map(function (n) { return String(n).split(/\s*\/\s*/); });
    return parts.map(function (ps) {
      var keep = ps.filter(function (x, i) {
        return parts.length < 2 || !parts.every(function (o) { return o[i] === x; });
      });
      return (keep.length ? keep : ps).map(function (x) {
        x = x.replace(/\s*\(.*?\)\s*/g, '').replace(/^Premium\s+/i, '').replace(/top[- ]grain/i, 'Top-Grain');
        return short ? x.replace(/\s+Leather$/i, '') : x;
      }).join(' · ');
    });
  }

  // ---- cart: Horizon module (window.AFDDCart, opens drawer) → plain AJAX + /cart fallback ----
  function addToCart(variantId) {
    var items = [{ id: Number(variantId), quantity: 1 }];
    if (window.AFDDCart) return window.AFDDCart.add({ items: items });
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || 'Could not add to cart');
        location.href = '/cart';
        return j;
      });
    });
  }

  // Product photo flies from the button into the header cart icon (Afroyla custom header: #afl-cart-toggle / -mobile).
  // Instant visual confirmation while /cart/add.js runs (~1.2 s server-side on this store). Skipped under reduced motion.
  function flyToCart(img, fromEl) {
    if (!img || !fromEl || !fromEl.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var target = [].slice.call(document.querySelectorAll('#afl-cart-toggle-mobile, #afl-cart-toggle, [data-hc-el="header-cart"]'))
      .filter(function (el) { return el.offsetParent !== null; })[0];
    if (!target) return;
    var a = fromEl.getBoundingClientRect(), b = target.getBoundingClientRect();
    var size = 72;
    var el = document.createElement('div');
    el.className = 'add-fly';
    el.style.backgroundImage = 'url(' + img + ')';
    el.style.left = (a.left + a.width / 2 - size / 2) + 'px';
    el.style.top = (a.top + a.height / 2 - size / 2) + 'px';
    document.body.appendChild(el);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    el.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 60) + 'px) scale(.7)', opacity: 1, offset: 0.5 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.15)', opacity: 0.4 }
    ], { duration: 650, easing: 'cubic-bezier(.4,0,.6,1)', fill: 'forwards' }).onfinish = function () { el.remove(); };
  }

  // Button feedback shared by lightning + grid adds. Optimistic: "Added ✓" + fly animation right on tap; the drawer
  // confirms from the server response; on failure the label switches to "Sold out" / "Try again".
  function runAdd(btn, variantId, img) {
    if (btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Added ✓';
    btn.classList.add('is-added');
    flyToCart(img, btn);
    var done = function (txt, ms) { btn.textContent = txt; setTimeout(function () { btn.textContent = label; btn.disabled = false; btn.classList.remove('is-added'); }, ms); };
    addToCart(variantId).then(function () { done('Added ✓', 1200); }).catch(function (e) {
      btn.classList.remove('is-added');
      done(/sold out|not available|quantity|stock/i.test(e.message) ? 'Sold out' : 'Try again', 2200);
    });
  }

  // ---- phase + hero countdown ----
  function phase() { var t = now(); return t < START ? 'pre' : t < END ? 'live' : 'ended'; }
  var clockEl = root.querySelector('[data-add-clock]');
  var clockLabel = root.querySelector('[data-add-clock-label]');
  var endedEl = root.querySelector('[data-add-ended]');
  var lastPhase = '';

  function tickHero() {
    var p = phase();
    if (p === 'pre') { clockLabel.textContent = 'Sale starts in'; clockEl.textContent = hms(START - now()); }
    else if (p === 'live') { clockLabel.textContent = 'Sale ends in'; clockEl.textContent = hms(END - now()); }
    else { clockLabel.textContent = 'Sale has ended'; clockEl.textContent = ''; }
    if (p !== lastPhase) {
      lastPhase = p;
      root.classList.toggle('is-ended', p === 'ended');
      if (endedEl) endedEl.hidden = p !== 'ended';
    }
  }
  tickHero();
  setInterval(tickHero, 500);

  // [data-add-when="end"|"start"] → sale end (11:59 PM ET) / start in ET + visitor's local time
  root.querySelectorAll('[data-add-when]').forEach(function (el) {
    el.textContent = whenLabel(el.dataset.addWhen === 'start' ? START : END - 60000);
  });

  // Jump links: Horizon hijacks window.scrollTo — scrollIntoView is reliable
  root.querySelectorAll('[data-add-jump]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var el = document.querySelector(a.getAttribute('href'));
      if (!el) return;
      e.preventDefault();
      e.stopPropagation();
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  window.AFDD = {
    root: root, now: now, START: START, END: END, phase: phase,
    money: money, pct: pct, hms: hms, mmss: mmss, etTime: etTime, whenLabel: whenLabel, img: img, esc: esc,
    cleanTitle: cleanTitle, variantLabels: variantLabels, addToCart: addToCart, runAdd: runAdd
  };
})();
